import React from 'react';
import FormContainer from './FormContainer';

interface FormInputProps extends React.HTMLProps<HTMLLabelElement & HTMLInputElement> {
  combineLabel?: Boolean;
  darkMode?: Boolean;
  inputAddOn?: String;
  errorMessage?: String;
  disabledMessage?: String;
  description?: string;
  onChange?: (event: React.ChangeEvent<HTMLLabelElement & HTMLInputElement>) => void;
}

type Props = React.FC<FormInputProps>;

const FormInput: Props = ({ placeholder = 'Enter something...', ...props }) => {
  var { combineLabel, label, inputAddOn, errorMessage, disabledMessage, darkMode, className, ...cleanedProps } = props;

  const hasCombinedLabel = !!combineLabel && !props.description && !!label;

  return (
    <FormContainer {...props} hasCombinedLabel={hasCombinedLabel} className="group">
      <div
        className={`
          flex
          cursor-pointer 
          items-center 
          justify-center 
          bg-white
          p-8
          ${props.disabled ? 'bg-gray-lighter' : props.darkMode ? 'bg-white' : 'bg-gray-lighter'}
        `}
      >
        <input
          type="file"
          {...cleanedProps}
          className="
            outline-none
            peer
            z-10
            m-0
            box-border
            w-full
            cursor-pointer
            text-sm
            text-gray-darker
            disabled:cursor-not-allowed
            disabled:border-gray
            disabled:bg-gray-lighter
          "
        />

        <span
          className="
            z-10
            ml-8
            whitespace-nowrap
            border-transparent
            bg-gold 
            p-8
            text-center
            font-condensed
            text-xs
            uppercase
            leading-none
            tracking-widest
            text-black
            peer-disabled:cursor-not-allowed
            peer-disabled:bg-gray-lighter
            peer-disabled:text-gray-dark
          "
        >
          Choose Files
        </span>
        <span
          className="
            absolute
            inset-0
            z-0
            border-1
            border-gray
            group-hover:border-gold-darker
            group-hover:bg-gold-lighter
            peer-focus:border-gold
            peer-focus:shadow-form-focus
            peer-disabled:cursor-not-allowed
            peer-disabled:border-gray
            peer-disabled:bg-gray-lighter
          "
        />
      </div>
    </FormContainer>
  );
};

export default FormInput;
